import addIcon from 'assets/icons/add.svg';
import editIcon from 'assets/icons/editIcon.svg';
import eyeIcon from 'assets/icons/eye.svg';
import { observer } from 'mobx-react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import CustomAccordionHeader from './components/customAccordionHeader/NDCAccordionTabHeader';
import NDCEditModal from './components/ndcEditModal/ndcEditModal';
import NdcLoadingSkeleton from './components/ndcSkeleton/ndcSkeleton';
import NdcBultEditModal from './components/ndcStrategyBulkEditModal/ndcStrategyBulkEditModal';
import NdcViewModal from './components/ndcViewModal/ndcViewModal';
import NdcAddModal from './components/ndcAddModal/ndcAddModal';

import classes from './ndcStrategyTable.module.scss';
import { useNdcStrategyTable } from './useNdcStrategyTable';
import { NDCInformationInterface } from 'Interfaces/FactsInterfaces/drugInterfaces';
import { useState } from 'react';

const NdcStrategyTable = () => {
  const {
    columnDetails,
    ndcSections,
    isNcdTableLoading,
    selectedContractAccordionIndex,
    setSelectedContractAccordionIndex,
    toggleIsAllSelected,
    isBulkEditModalVisible,
    checkNdcSectionAllSelected,
    selectedNdcSectionContractNumber,
    toggleNdcBulkEditStrategyModal,
    isNdcStrategyModalVisible,
    selectedNdcStrategyIndexesForEdit,
    addNdcIndexForMultiEdit,
    handleEditSingleNdcStrategy,
    handleViewSingleNdcStrategy,
    handleAddSingleNdcStrategy,
    toggleNdcStrategyModalVisibility,
    checkIfNdcIndexIsSelected,
    handleMultiEditButtonClick,
    isNDCViewVisible,
    isNDCAddVisible,
    toggleNDCViewModalVisibility,
    toggleNDCAddModalVisibility,
    isConceptsListLoading,
  } = useNdcStrategyTable();

  const [rowData, setRowData] = useState<NDCInformationInterface>({} as NDCInformationInterface);

  const handleAddRowData = (row: NDCInformationInterface) => {
    setRowData(row);
  };

  return (
    <div className={classes.ndcStrategyContainer}>
      <div className={classes.header}>NDC Strategy</div>

      {/* NDC Strategy table should be visible if any of ndc single or bulk edit modal is opened, or ndcTable data is not loading */}
      {(!isNcdTableLoading && !isConceptsListLoading) ||
      isNdcStrategyModalVisible ||
      isBulkEditModalVisible ? (
        <Accordion
          key={JSON.stringify(ndcSections())}
          className={classes.ndcTableAccordion}
          multiple
          activeIndex={[selectedContractAccordionIndex || 0]}
        >
          {ndcSections().map((row, rowIndex) => {
            return (
              <AccordionTab
                className={classes.accordionInstance}
                header={<CustomAccordionHeader headerData={row} />}
              >
                <div className={classes.strategyTablesContainer}>
                  <table className={classes.datatable}>
                    <thead>
                      <tr>
                        {/* for row selecting column */}
                        <th style={{ width: '5%' }}>
                          {/* <div className={classes.tooltip}>Click To Select All</div> */}
                          <Checkbox
                            onClick={() => toggleIsAllSelected(row)}
                            className={classes.rowSelectCheckBox}
                            checked={
                              selectedNdcSectionContractNumber === row.ContractNumber &&
                              checkNdcSectionAllSelected(row)
                            }
                          />
                        </th>

                        {columnDetails.map(column => {
                          return (
                            <th style={{ width: column.width }} key={column.key}>
                              {column.label}
                            </th>
                          );
                        })}
                        {/* for edit column icon */}
                        <th style={{ width: '1rem' }} className={classes.editButtonColumn}>
                          {''}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {row.RowData.map((row, index) => {
                        return (
                          <tr key={index}>
                            {/* For row selector checkbox */}
                            <td style={{ width: '5rem' }}>
                              <Checkbox
                                onClick={() => {
                                  addNdcIndexForMultiEdit(index, row.ContractNumber);
                                  handleAddRowData(row);
                                }}
                                className={classes.rowSelectCheckBox}
                                onChange={() => {}}
                                checked={checkIfNdcIndexIsSelected(index, row.ContractNumber)}
                              ></Checkbox>
                            </td>
                            <td>{row.NDC11 ? row.NDC11 : '--'}</td>
                            <td>{row.PackSize ? parseInt(row.PackSize.toString()) : '--'}</td>
                            <td>{row.SupplierName}</td>
                            <td>{row.MarketPrice ? row.MarketPrice : '--'}</td>
                            <td>{row.PPS ? row.PPS : '--'}</td>
                            <td>{row.PPSReason ? row.PPSReason : '--'}</td>
                            <td>{row.Segmentation ? row.Segmentation : '--'}</td>
                            <td>{row.DPstratergy ? row.DPstratergy : '--'}</td>
                            {/* edit column icon */}
                            <td style={{ width: '1rem' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <Button
                                  onClick={() => {
                                    handleAddSingleNdcStrategy(index, row);
                                    setSelectedContractAccordionIndex(rowIndex);
                                  }}
                                  className={classes.editIconButton}
                                  icon={
                                    <img
                                      style={{
                                        height: '12px',
                                        width: '12px',
                                      }}
                                      src={addIcon}
                                      alt="edit"
                                    />
                                  }
                                  rounded
                                  text
                                  aria-label="Filter"
                                />
                                <Button
                                  onClick={() => {
                                    handleEditSingleNdcStrategy(index, row);
                                    setSelectedContractAccordionIndex(rowIndex);
                                  }}
                                  className={classes.editIconButton}
                                  icon={
                                    <img
                                      style={{
                                        height: '12px',
                                        width: '12px',
                                      }}
                                      src={editIcon}
                                      alt="edit"
                                    />
                                  }
                                  rounded
                                  text
                                  aria-label="Filter"
                                />
                                <Button
                                  onClick={() => {
                                    handleViewSingleNdcStrategy(index, row);
                                    setSelectedContractAccordionIndex(rowIndex);
                                  }}
                                  icon={
                                    <img
                                      style={{
                                        height: '15px',
                                        width: '15px',
                                      }}
                                      src={eyeIcon}
                                      alt="edit"
                                    />
                                  }
                                  rounded
                                  text
                                  aria-label="Filter"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {selectedNdcStrategyIndexesForEdit.length > 0 &&
                    selectedNdcSectionContractNumber === row.ContractNumber && (
                      <div className={classes.editButtonDivWrapper}>
                        <Button
                          onClick={() =>
                            selectedNdcStrategyIndexesForEdit.length < 2
                              ? handleAddSingleNdcStrategy(rowIndex, rowData)
                              : handleMultiEditButtonClick(rowIndex)
                          }
                          className={classes.editButton}
                        >
                          {selectedNdcStrategyIndexesForEdit.length < 2 ? 'Add' : 'Bulk Add'}
                        </Button>
                      </div>
                    )}
                </div>
              </AccordionTab>
            );
          })}
        </Accordion>
      ) : (
        <NdcLoadingSkeleton />
      )}

      {isNdcStrategyModalVisible && (
        <NDCEditModal
          visibility={isNdcStrategyModalVisible}
          toggleVisibility={toggleNdcStrategyModalVisibility}
        />
      )}
      {isNDCViewVisible && (
        <NdcViewModal
          visibility={isNDCViewVisible}
          toggleVisibility={toggleNDCViewModalVisibility}
        />
      )}
      {isNDCAddVisible && (
        <NdcAddModal visibility={isNDCAddVisible} toggleVisibility={toggleNDCAddModalVisibility} />
      )}
      {isBulkEditModalVisible && (
        <NdcBultEditModal
          visibility={isBulkEditModalVisible}
          toggleVisibility={toggleNdcBulkEditStrategyModal}
        />
      )}
    </div>
  );
};

export default observer(NdcStrategyTable);
